import { render, staticRenderFns } from "./AuthenticationButton.vue?vue&type=template&id=ac947cb8"
import script from "./AuthenticationButton.vue?vue&type=script&lang=js"
export * from "./AuthenticationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports